import React from "react";
import { Box, Text } from "@mantine/core";
import { DiscountPreset } from "../../../types/discounts";
import { formatDiscountValue } from "../../../utils/discountFormatting";
import DiscountPresetActions from "./DiscountPresetActions";
import styles from "./DiscountPresetCard.module.css";

export interface DiscountPresetCardProps {
  preset: DiscountPreset;
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (preset: DiscountPreset) => void;
  onDelete: (preset: DiscountPreset) => void;
}

/**
 * Phone (≤768px) rendering of one discount preset: name, "type · value"
 * caption, and the permission-gated Edit / Delete actions.
 */
export default function DiscountPresetCard({
  preset,
  canEdit,
  canDelete,
  onEdit,
  onDelete,
}: DiscountPresetCardProps) {
  return (
    <Box className={styles.card} data-testid="discount-preset-card">
      <Box className={styles.body}>
        <Text fw={600} className={styles.name}>
          {preset.name}
        </Text>
        <Text size="sm" c="dimmed">
          {`${preset.discount_type} · ${formatDiscountValue(
            preset.discount_type,
            preset.amount,
          )}`}
        </Text>
      </Box>
      <Box className={styles.actions}>
        <DiscountPresetActions
          preset={preset}
          canEdit={canEdit}
          canDelete={canDelete}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </Box>
    </Box>
  );
}
